export default "__VITE_ASSET__BhHWuFF___"